import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/client/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "blockchain"
    }}>{`Blockchain`}</h1>
    <blockquote>
      <p parentName="blockquote">{`Blockchain is a non-modifiable ledger system that records the transaction and it is shared across the node i.e, the computer participating in the network.`}</p>
    </blockquote>
    <p><img alt="Blockchain Development" src="https://img.freepik.com/free-vector/security-concept-illustration-people-holding-chain_53876-43028.jpg?t=st=1652793493~exp=1652794093~hmac=56d57921d4f37f94370ef406fb5327b90da8af413bf90286bf2553de7feeae1c&w=740" /></p>
    <p>{`The blockchain was popularized by a person (or group of people) using the presumed pseudonymous name Satoshi Nakamoto in 2008. Blockchain solved the problem of decentralization of data in Web2. As the data is shared across the different nodes, there is no one particular person or organization having all the data.`}</p>
    <p>{`Web3 applications are based on the blockchain concept. Bitcoin is a use case of blockchain. It works as a ledger system for payment but blockchain can be used for any data transaction. There is various network based on blockchain such as Ethereum, Polygon, Solona, Avalanche, and other.`}</p>
    <h1 {...{
      "id": "resouces-to-learn-blockchain"
    }}>{`Resouces to learn Blockchain`}</h1>
    <ul>
      <li parentName="ul">{`📄`}<a parentName="li" {...{
          "href": "https://www.ibm.com/in-en/topics/what-is-blockchain"
        }}>{`What is blockchain technology?`}</a></li>
      <li parentName="ul">{`▶️`}<a parentName="li" {...{
          "href": "https://www.udemy.com/course/blockchain-theory-101/"
        }}>{`Blockchain Theory 101`}</a></li>
      <li parentName="ul">{`▶️`}<a parentName="li" {...{
          "href": "https://www.youtube.com/watch?v=QCvL-DWcojc&t=7471s"
        }}>{`Blockchain Full Course - 4 Hours | Blockchain Tutorial | Blockchain Technology Explained | Edureka`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      